export default __webpack_public_path__ + "static/media/seat.f41775fa.svg";